export default (fullPhoneNumber, countryCodes) => {
    if (!fullPhoneNumber) {
        return {};
    }
    let code = null;
    let phoneNumber = '';
    const temp = fullPhoneNumber.split(' ');
    if (temp.length === 2) {
        code = temp[0].includes('++') ? temp[0].replace('+', '') : temp[0];
        code = countryCodes.find(c => c.label === code);
    }
    if (temp.length >= 1) {
        phoneNumber = temp.length === 2 ? temp[1] : temp[0];
    }

    return {
        code: code,
        phoneNumber: phoneNumber,
    };
};
